import React from "react";
import {
    createStyles,
    Paper,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import { Save } from "@material-ui/icons";
import arrayMove from "array-move";
import { connect } from "react-redux";
import {
    SortableContainer,
    SortableElement,
    SortableHandle
} from "react-sortable-hoc";
import { bindActionCreators } from "redux";
import IAuctionDetail from "../../../models/auction/IAuctionDetail";
import { ISortParcel } from "../../../models/parcel/ISortParcel";
import Constants from "../../../models/utility/Constants";
import { IAppDispatch, IAppState } from "../../../store";
import * as ParcelStore from "../../../store/ParcelStore";
import LoaderButton from "../LoaderButton";

type ParcelOrderRowProps = ParcelStore.IParcelStoreState &
    typeof ParcelStore.actionCreators &
    WithStyles<typeof styles> & {
        auction: IAuctionDetail;
    };

interface IParcelOrderRowState {
    sortParcels: ISortParcel[];
}

const styles = (theme: Theme) =>
    createStyles({
        buttonWrapper: { marginTop: theme.spacing(2) },
        paperRoot: {
            backgroundColor: "#eee",
            marginBottom: theme.spacing(4),
            marginTop: theme.spacing(4),
            padding: theme.spacing(4)
        },
        paperTabDetails: {
            marginLeft: 4,
            marginRight: 4,
            padding: 24
        }
    });

class ParcelOrderRow extends React.PureComponent<
    ParcelOrderRowProps,
    IParcelOrderRowState
> {
    constructor(props: ParcelOrderRowProps) {
        super(props);
        const sortParcels: ISortParcel[] = [];
        props.parcels.forEach((parcel) => {
            const sortParcel: ISortParcel = {
                auctionId: props.auction.auctionId,
                name: parcel.name,
                index: parcel.index,
                parcelId: parcel.parcelId,
                path: []
            };

            sortParcels.push(sortParcel);
        });

        this.state = {
            sortParcels
        };
    }

    public render() {
        const classes = this.props.classes;
        const auctionLiveOrClosed =
            this.props.auction &&
            (this.props.auction.isLive || this.props.auction.isCompleted);

        const title = "Admin - Order Parcels";
        Constants.SetDocumentTitle(title);

        return (
            <Paper className={classes.paperRoot} elevation={2}>
                {auctionLiveOrClosed && this.renderSortedParcels()}
                {!auctionLiveOrClosed && (
                    <SortableList
                        items={this.state.sortParcels}
                        onSortEnd={this.onSortEnd}
                        useDragHandle
                    />
                )}
                {!auctionLiveOrClosed && this.state.sortParcels.length > 1 && (
                    <LoaderButton
                        loading={this.props.savingParcelOrder}
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={this.onParcelOrderSave}
                    >
                        <Save />
                        &nbsp; Update
                    </LoaderButton>
                )}
            </Paper>
        );
    }

    private renderSortedParcels = () => {
        return (
            <div className="div-sortable-container">
                {this.state.sortParcels.map((value) => (
                    <div className="div-sortable-item" key={value.parcelId}>
                        <Typography component="h6" variant="h6">
                            {value.name}
                        </Typography>
                    </div>
                ))}
            </div>
        );
    };

    private onSortEnd = ({
        oldIndex,
        newIndex
    }: {
        oldIndex: number;
        newIndex: number;
    }) => {
        this.setState({
            sortParcels: arrayMove(this.state.sortParcels, oldIndex, newIndex)
        });
    };

    private onParcelOrderSave = (e: React.MouseEvent) => {
        e.preventDefault();

        const sortParcels: ISortParcel[] = this.state.sortParcels;
        sortParcels.map((parcel, index) => (parcel.index = index));
        this.props.updateParcelOrder(sortParcels);
    };
}

// ReSharper disable once InconsistentNaming
const DragHandle = SortableHandle(() => (
    <div className="div-sortable-handle" />
));

// ReSharper disable once InconsistentNaming
const SortableItem = SortableElement(({ value }: { value: ISortParcel }) => (
    <div className="div-sortable-item">
        <DragHandle />
        <Typography component="h6" variant="h6">
            {value.name}
        </Typography>
    </div>
));

// ReSharper disable once InconsistentNaming
const SortableList = SortableContainer(
    ({ items }: { items: ISortParcel[] }) => {
        return (
            <div className="div-sortable-container">
                {items.map((value, index) => (
                    <SortableItem
                        key={value.parcelId}
                        index={index}
                        value={value}
                    />
                ))}
            </div>
        );
    }
);

const reduxState = (state: IAppState) =>
    Object.assign({}, state.parcelStoreState);
const reduxDispatch = (dispatch: IAppDispatch) =>
    bindActionCreators(Object.assign({}, ParcelStore.actionCreators), dispatch);

export default withStyles(styles)(
    connect(reduxState, reduxDispatch)(ParcelOrderRow)
);
